import API from './api';

export const getAllPosts = async () => {
  try {
    const res = await API.get('/post');
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getPostBySlug = async (slug) => {
  try {
    const res = await API.get(`/post/${slug}`);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getPostsOfUser = async (id) => {
  try {
    const res = await API.get(`/post/user/${id}`);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const addPost = async (formData) => {
  try {
    const res = await API.post(`/post`, formData);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const updatePost = async (formData, id) => {
  try {
    const res = await API.put(`/post/${id}`, formData);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const deletePost = async (id) => {
  try {
    const res = await API.delete(`/post/${id}`);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const likePost = async (id) => {
  try {
    const res = await API.put(`/post/like/${id}`);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const unlikePost = async (id) => {
  try {
    const res = await API.put(`/post/unlike/${id}`);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const addComment = async (comment, id) => {
  try {
    const res = await API.put(`/post/comment/${id}`, comment);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const deleteComment = async (postId, commentId) => {
  try {
    const res = await API.put(`/post/uncomment/${postId}/${commentId}`);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const addReport = async (report, id) => {
  try {
    const res = await API.put(`/report/${id}`, report);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const deleteReport = async (report, id) => {
  try {
    const res = await API.delete(`/report/${id}`);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const addRating = async (rating, id) => {
  try {
    const res = await API.put(`post/rating/${id}`, rating);
    return res.data;
  } catch (err) {
    throw err;
  }
};

// export const deleteRating = async (rating, id) => {
//     try {
//            const res = await API.put(`post/rating/${id}`, rating);
//            return res.data;
//          } catch (err) {
//            throw err;
//          }
//        };
